<p-dialog header="{{addEditBatchdHeader}}" [modal]="true" [(visible)]="displayBatchForm" [style]="{width: '50vw'}"
    [baseZIndex]="10000" (onHide)="invalidData=false">
    <form [formGroup]="batchForm">
        <div class="p-grid">
            <div class="p-col-12">
                <label for="name">Name <span style="color: red;">*</span></label>
                <input type="text" pInputText formControlName="name">
                <small *ngIf="invalidData" class="p-invalid">
                    Name exists in the list already
                </small>
            </div>
            <div class="p-col-12">
                <label for="name">Description</label>
                <input type="text" formControlName="description" pInputText style="width: 100%;">
            </div>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <button pButton (click)="close()" label="Cancel" class="p-button-secondary"></button>
        <button pButton [disabled]="!batchForm.valid" (click)="saveBatch(batchForm.value)" label="Save"></button>
    </ng-template>
</p-dialog>